// Site update log — add new entries at the top (newest first).
// Each entry: { date: "YYYY-MM-DD", title: string, body: string }

export const siteUpdates = [
  {
    date: "2026-01-27",
    title: "Welcome to PCFA",
    body: "Welcome to the Pro Clubs Football Association management platform! This is the official launch of PCFA, a comprehensive web-based solution designed to streamline league management, team organisation, and player performance tracking. The platform includes team and player administration, match tracking with appearance records, dynamic league tables, multi-season support, and a transfer request system. User accounts support role-based access including admin capabilities.",
  },
];
